import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=93e4ee70&scoped=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=js"
export * from "./ProjectOverview.vue?vue&type=script&lang=js"
import style0 from "./ProjectOverview.vue?vue&type=style&index=0&id=93e4ee70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e4ee70",
  null
  
)

export default component.exports